import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'ShopTheLookLazy',
        path: () => path.join(__dirname, './ShopTheLook'),
        resolve: () => require.resolveWeak('./ShopTheLook'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "ShopTheLookLazy" */ './ShopTheLook')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
